import { AxiosRequestConfig, AxiosResponse } from 'axios'

import { ICheckoutResponse } from '../types/api/checkout'
import { publicRequest } from './publicRequest'

export const postOnCheckout = async (
  data: any,
  freeTicket = false
): Promise<ICheckoutResponse> => {
  if (freeTicket) {
    delete data.attributes.city
    delete data.attributes.country
    delete data.attributes.state
    delete data.attributes.street_address
  }

  const response: AxiosResponse<ICheckoutResponse, AxiosRequestConfig> =
    await publicRequest.post(`v1/on-checkout`, { data })

  return response.data
}

export const updateCheckout = async (data: any): Promise<ICheckoutResponse> => {
  const response: AxiosResponse<ICheckoutResponse, AxiosRequestConfig> =
    await publicRequest.post(`v1/checkout`, { data })

  return response.data
}
